"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTournamentResults = exports.mockTournamentLeaderboardUsers = exports.mockPastTournaments = exports.mockUpcomingTournaments = void 0;
exports.mockUpcomingTournaments = {
    success: true,
    tournaments: [
        {
            uuid: '37ee6981-7378-4020-b7a1-495f8abbdc9c',
            name: 'inProgress started late',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() - 30 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() - 25 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 5,
            participants: [
                {
                    nickname: 'Simba',
                    profilePicture: 'user-8',
                },
                {
                    nickname: 'Pumbaa',
                    profilePicture: 'user-6',
                },
                {
                    nickname: 'Zazu',
                    profilePicture: 'user-22',
                },
            ],
        },
        {
            uuid: '11dd1cf1-ff99-488d-a2b6-5e62bfc31cdb',
            name: 'inProgress started early',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() + 10 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() - 5 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '567d1cf1-ff99-488d-a2b6-5e62bfc31cdb',
            name: 'inProgress will start soon',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() + 10 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() + 5 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '74eb1403-c8f5-434c-b012-43b1fd4e9f74',
            name: 'Opened Tournament',
            status: 'opened',
            dateTime: new Date(new Date().getTime() - 5 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 3,
            participants: [
                {
                    nickname: 'Simba',
                    profilePicture: 'user-8',
                },
                {
                    nickname: 'Pumbaa',
                    profilePicture: 'user-6',
                },
                {
                    nickname: 'Zazu',
                    profilePicture: 'user-22',
                },
            ],
        },
        {
            uuid: '9c9db309-fee5-4c2f-81f0-db52b85ba6d6',
            name: 'Pending Far Future',
            status: 'pending',
            dateTime: new Date(new Date().getTime() + 7 * 24 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '85638c92-bac1-4a17-a38e-74d73884d3a7',
            name: 'Pending Near Future',
            status: 'pending',
            dateTime: new Date(new Date().getTime() + 27 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: 'bc5e8faf-ecd7-4fc7-b899-eb9a5d4d6b6c',
            name: 'Pending Not Run',
            status: 'pending',
            dateTime: new Date(new Date().getTime() - 13 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
    ],
};
exports.mockPastTournaments = {
    success: true,
    tournaments: [
        {
            uuid: 'e1f7376b-6f3f-4680-810a-b5c4608a5441',
            name: 'Past Tournament 1',
            dateTime: new Date(new Date().getTime() - 30 * 60000).toISOString(),
            numberOfRounds: 2,
            numParticipatedUsers: 8,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            userScore: 24320,
            didParticipate: true,
            didManage: false,
        },
        {
            uuid: '1a50c9f9-4a83-463b-86fa-494e2898e93a',
            name: 'Past Tournament 2',
            dateTime: new Date(new Date().getTime() - 30 * 60000).toISOString(),
            numberOfRounds: 2,
            numParticipatedUsers: 8,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            userScore: 24320,
            didParticipate: true,
            didManage: false,
        },
        {
            uuid: 'c34d1f05-61e8-477e-8660-74ab4de5679e',
            name: 'Past Tournament 3',
            dateTime: new Date(new Date().getTime() - 30 * 60000).toISOString(),
            numberOfRounds: 2,
            numParticipatedUsers: 8,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            userScore: 24320,
            didParticipate: true,
            didManage: false,
        },
    ],
};
exports.mockTournamentLeaderboardUsers = {
    success: true,
    currentUser: {
        uuid: '21378e3dwbeid1',
        nickname: 'current-user',
        rank: 2,
        score: 429832,
        avatar: 'user-4',
    },
    totalUsers: 12,
    leaderboard: [
        {
            rank: 1,
            nickname: 'user1',
            score: 100,
            avatar: 'user-9',
            userId: '2118e3dwbeid1',
        },
        {
            rank: 2,
            nickname: 'user2',
            score: 200,
            avatar: 'user-9',
            userId: '21378e3dw2beid1',
        },
        {
            rank: 3,
            nickname: 'user3',
            score: 300,
            avatar: 'user-4',
            userId: '21378e3dwb31eid1',
        },
        {
            rank: 4,
            nickname: 'user4',
            score: 300,
            avatar: 'user-5',
            userId: '21378e3dwb4eid1',
        },
        {
            rank: 5,
            nickname: 'user3',
            score: 300,
            avatar: 'user-1',
            userId: '21378e3dw12beid1',
        },
        {
            rank: 6,
            nickname: 'user3',
            score: 300,
            avatar: 'user-2',
            userId: '21378e3dw4beid1',
        },
        {
            rank: 7,
            nickname: 'user3',
            score: 300,
            avatar: 'user-4',
            userId: '211378e3dwbeid1',
        },
        {
            rank: 8,
            nickname: 'user3',
            score: 300,
            avatar: 'user-5',
            userId: '21378e3d3wbeid1',
        },
        {
            rank: 9,
            nickname: 'user3',
            score: 300,
            avatar: 'user-5',
            userId: '213781e3dwbeid1',
        },
        {
            rank: 10,
            nickname: 'user3',
            score: 300,
            avatar: 'user-1',
            userId: '21378e32dwbeid1',
        },
        {
            rank: 11,
            nickname: 'user3',
            score: 300,
            avatar: 'user-3',
            userId: '21378e3d2wbeid1',
        },
        {
            rank: 12,
            nickname: 'user3',
            score: 300,
            avatar: 'user-5',
            userId: '21378e3dwbeid1',
        },
    ],
};
exports.mockTournamentResults = {
    success: true,
    userResults: {
        tournamentData: {
            name: 'leaderboard test',
            dateTime: '2023-06-06T09:00:00.000Z',
            numberOfRounds: 1,
            participants: 3,
            winner: 'Ronit User',
            frameworks: ['.NET', 'Java', 'Node.JS'],
        },
        userResults: {
            rank: 2,
            score: 3963,
            vulnerabilities: [
                {
                    vulnerabilityName: 'Race Condition',
                    rating: 100,
                },
                {
                    vulnerabilityName: 'XXE Processing',
                    rating: 100,
                },
                {
                    vulnerabilityName: 'Horizontal Privilege Escalation',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'SQL Injection',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'Use of Insufficiently Random Values',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'Insecure Password Storage',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'Reflected XSS',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'OS Command Injection',
                    rating: 0,
                },
                {
                    vulnerabilityName: 'Cross Site Request Forgery',
                    rating: 0,
                },
            ],
            questionsBreakdown: [
                [
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'OS Command Injection',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'Horizontal Privilege Escalation',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'Cross Site Request Forgery',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'SQL Injection',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'SQL Injection',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'Reflected XSS',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'Use of Insufficiently Random Values',
                    },
                    {
                        correct: false,
                        allUsersSuccess: 0,
                        vulnerabilityName: 'Insecure Password Storage',
                    },
                    {
                        correct: true,
                        allUsersSuccess: 100,
                        vulnerabilityName: 'Race Condition',
                    },
                    {
                        correct: true,
                        allUsersSuccess: 100,
                        vulnerabilityName: 'XXE Processing',
                    },
                ],
            ],
            framework: 'Java',
        },
    },
};
